<template>
  <tr class="request-item-row">
    <td>
      <label>
        <input
          v-model="selectThisRow"
          type="checkbox"
          class="select-this-item"
          @change="changeItem"
        />
      </label>
    </td>
    <td class="request-item-name">
      {{ name }}
    </td>
    <td class="request-item-quantity-purchased">
      {{ quantityPurchased }}
    </td>
    <td v-if="previousRequestsExist" class="request-item-quantity-already-requested">
      {{ quantityAlreadyRequested }}
    </td>
    <td class="request-item-quantity">
      <span v-if="quantityCouldReturn === 1" class="request-item-quantity-input">
        1
      </span>
      <label v-else-if="selectThisRow" class="request-item-quantity-already-requested">
        <select
          v-model="quantityToReturn"
          class="form-input quantity-input"
          @change="changeItem"
        >
          <option disabled class="first">Select a quantity to return</option>
          <template v-for="quantityOption in quantityCouldReturn">
            <option
              :key="quantityOption"
              :value="quantityOption"
            >
              {{ quantityOption }}
            </option>
          </template>
        </select>
      </label>
    </td>
    <td class="request-item-reason">
      <label>
        <select
          v-if="selectThisRow"
          v-model="returnReasonId"
          class="form-input reason-input"
          @change="changeItem"
        >
          <option disabled class="first">Select a reason for the return</option>
          <template v-for="returnReason in returnReasons">
            <option
              :key="returnReason.id"
              :value="returnReason.id"
            >
              {{ returnReason.name }}
            </option>
          </template>
        </select>
      </label>
    </td>
  </tr>
</template>

<script>
  export default {
    props: {
      selectAll: {
        type: Boolean,
        required: false,
        default: false
      },
      name: {
        type: String,
        required: true
      },
      lineItemId: {
        type: Number,
        required: true
      },
      variantId: {
        type: Number,
        required: true
      },
      quantityPurchased: {
        type: Number,
        required: true
      },
      quantityAlreadyRequested: {
        type: Number,
        required: true
      },
      quantityCouldReturn: {
        type: Number,
        required: true
      },
      returnReasons: {
        type: Array,
        required: true
      },
      previousRequestsExist: {
        type: Boolean,
        required: true
      },
      returnReasonIdForAll: {
        type: Number,
        required: false,
        default: null
      },
    },
    data() {
      return {
        selectThisRow: this.selectAll,
        quantityToReturn: this.quantityCouldReturn === 1 ? 1 : null,
        returnReasonId: this.returnReasonIdForAll || null,
      }
    },
    methods: {
      changeItem() {
        if (this.selectThisRow && this.returnReasonId && this.quantityToReturn) {
          this.$emit('add-item', {
            line_item_id: this.lineItemId,
            variant_id: this.variantId,
            quantity_requested: this.quantityToReturn,
            return_reason_id: this.returnReasonId
          });
        } else {
          this.$emit('remove-item', this.lineItemId)
        }
      },
    }
  }
</script>
